import { isEmpty } from 'lodash'
import { AllClinicsAvailabilitiesGroupedByPeriod, AvailabilitiesPeriod } from '../types'

export const getPeriodWithNextAvailableSlot = (
  clinicId: string,
  availabilitiesGrouped: AllClinicsAvailabilitiesGroupedByPeriod | undefined,
  dayWithNextAvailableSlot?: string
): AvailabilitiesPeriod | undefined => {
  if (isEmpty(availabilitiesGrouped)) return

  const availabilities = availabilitiesGrouped[clinicId]
  const indexOfFirstWeekWithAvailabilities = availabilities.findIndex((av) =>
    av.some((a) => a.date === dayWithNextAvailableSlot)
  )

  const periodWithNextAvailableSlotsForOneClinic: AvailabilitiesPeriod = {}

  Object.entries(availabilitiesGrouped).forEach(([clinicId, clinicAvailabilities]) => {
    periodWithNextAvailableSlotsForOneClinic[clinicId] = clinicAvailabilities[indexOfFirstWeekWithAvailabilities]
  })

  return periodWithNextAvailableSlotsForOneClinic
}
